import React, { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setup } from '@store/tempDashboardTab/actions';
import { initializingSelector } from '@store/tempDashboardTab/selector';
import TempTimelineTab from '../Timeline/TempTimelineTab';

const TYPE_MAP = {
  timeline: TempTimelineTab,
};

function useQueryParams() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function TempDashboard() {
  const { type }: any = useParams();
  const query = useQueryParams();
  const dispatch = useDispatch();
  const initializing = useSelector(initializingSelector);
  const Page = useMemo(() => TYPE_MAP[type] || null, []);

  useEffect(() => {
    dispatch(setup(type, query));
  }, []);

  if (initializing) {
    return <>Loading...</>;
  }

  return <Page />;
}

export default TempDashboard;
